module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold.01b84c4e.woff";